import React from "react";
import Speciality from "Pages/Profile/Speciality";

export default function Dashtalentpagetheme() {
  return (
    <>
      <Speciality />
    </>
  );
}
